import { render, staticRenderFns } from "./ExibirLei.vue?vue&type=template&id=c4dd865c"
import script from "./ExibirLei.vue?vue&type=script&lang=js"
export * from "./ExibirLei.vue?vue&type=script&lang=js"
import style0 from "./ExibirLei.vue?vue&type=style&index=0&id=c4dd865c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports